import PropTypes from "prop-types";

export default PropTypes.shape({
	allowOverride: PropTypes.bool,
	minPossibleValue: PropTypes.number,
	maxPossibleValue: PropTypes.number,
	applyFeedMargins: PropTypes.number
});
